// src/utils/api.js
import axios from "axios";

axios.defaults.withCredentials = true; // Cho phép gửi cookie

let csrfToken = null; // Lưu CSRF token tạm thời

// Hàm lấy CSRF token từ backend
export async function fetchCsrfToken() {
    try {
        const response = await axios.get('/api/contact', { withCredentials: true });
        csrfToken = response.headers["x-csrf-token"]?.split(',')[0];
        // console.log("Đã lấy CSRF Token:", csrfToken);
    } catch (error) {
        console.error("Lỗi khi lấy CSRF token:", error);
    }
}

// Hàm gửi request POST với CSRF token
export async function postData(url, data) {
    // Nếu chưa có token thì gọi fetchCsrfToken
    if (!csrfToken) {
        await fetchCsrfToken();
    }

    if (!csrfToken) {
        console.log("Không thể lấy CSRF token! Vui lòng thử lại.");
        return;
    }

    return axios.post(url, data, {
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrfToken,
        },
        withCredentials: true,
    });
}
